import { leadConstants } from '../actions/constants/leadConstants';

export const getLeadReducer = (state = {}, action: any) => {
  switch (action.type) {
    case leadConstants.listLeadsRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case leadConstants.listLeadsSuccess:
      return { isLoading: false, isSuccess: true, isError: false, leaddata: action.payload };
    case leadConstants.listLeadsFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const createLeadReducer = (state = {}, action: any) => {
  switch (action.type) {
    case leadConstants.saveLeadRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case leadConstants.saveLeadSuccess:
      return { isLoading: false, isSuccess: true, isError: false, leaddata: action.payload };
    case leadConstants.saveLeadFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const viewLeadReducer = (state = {}, action: any) => {
  switch (action.type) {
    case leadConstants.viewLeadRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case leadConstants.viewLeadSuccess:
      return { isLoading: false, isSuccess: true, isError: false, leadview: action.payload };
    case leadConstants.viewLeadFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const updateLeadReducer = (state = {}, action: any) => {
  switch (action.type) {
    case leadConstants.updateLeadRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case leadConstants.updateLeadSuccess:
      return { isLoading: false, isSuccess: true, isError: false, leaddata: action.payload };
    case leadConstants.updateLeadFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const deleteLeadReducer = (state = {}, action: any) => {
  switch (action.type) {
    case leadConstants.deleteLeadRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case leadConstants.deleteLeadSuccess:
      return { isLoading: false, isSuccess: true, isError: false, deleted: action.payload };
    case leadConstants.deleteLeadFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const addFollowUpReducer = (state = {}, action: any) => {
  switch (action.type) {
    case leadConstants.addFollowUpRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case leadConstants.addFollowUpSuccess:
      return { isLoading: false, isSuccess: true, isError: false, followUpdata: action.payload };
    case leadConstants.addFollowUpFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};
